export const isImage = (url)=> {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}
export const isVideo = (url) => {
  return /\.(mpg|mp2|mpeg|mpe|mpv|mp4)$/.test(url);
}